/**
 * Currency Utility Functions
 * Handles currency formatting and display for ticket pricing
 */

export const CURRENCIES = {
  GHS: {
    code: "GHS",
    symbol: "₵",
    name: "Ghana Cedis",
  },
  USD: {
    code: "USD",
    symbol: "$",
    name: "US Dollars",
  },
};
export const getCurrencySymbol = (currencyCode) => {
  if (!currencyCode) return CURRENCIES.GHS.symbol; // Default to Cedis
  const currency = CURRENCIES[currencyCode.toUpperCase()];
  return currency ? currency.symbol : CURRENCIES.GHS.symbol;
};

export const formatPrice = (price, currencyCode = "GHS") => {
  const numericPrice = parseFloat(price || 0);
  if (numericPrice === 0) {
    return "FREE";
  }
  const symbol = getCurrencySymbol(currencyCode);
  return `${symbol}${numericPrice.toFixed(2)}`;
};

export const formatPriceRange = (minPrice, maxPrice, currencyCode = "GHS") => {
  const min = parseFloat(minPrice || 0);
  const max = parseFloat(maxPrice || 0);
  const symbol = getCurrencySymbol(currencyCode);
  
  // If both are 0, show FREE
  if (min === 0 && max === 0) {
    return "FREE";
  }
  
  // If min is 0 but max is not, show "FREE - ₵X"
  if (min === 0 && max > 0) {
    return `FREE - ${symbol}${max.toFixed(2)}`;
  }
  
  if (min === max) {
    return `${symbol}${min.toFixed(2)}`;
  }
  return `${symbol}${min.toFixed(2)} - ${symbol}${max.toFixed(2)}`;
};

export const getTicketCurrency = (ticket) => {
  // Check for currency field
  if (ticket?.currency) {
    return ticket.currency.toUpperCase();
  }
  return "GHS";
};

